import {FilesI18n} from '@/locales/base.message.locales';

export const files: FilesI18n = {
  search: 'Search',
  title: 'File',
  description: 'Description',
  buttons: {
    download: 'Download',
  },
};
